import { getFocusRingStyles } from '../../MilestoneRoadmapDocuments.styles';

export const getRowStyles = isFirst => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  width: '100%',
  py: '6px',
  cursor: 'pointer',
  textAlign: 'left',
  ...(isFirst ? {} : { borderTop: ({ palette }) => `1px solid ${palette.divider}` }),
});

export const nameStyles = {
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: 'text.primary',
};

export const metaRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
};

export const dateStyles = { color: 'text.secondary' };

export const actionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  ml: 'auto',
};

export const actionButtonStyles = {
  display: 'flex',
  p: '2px',
  borderRadius: '4px',
  color: 'text.secondary',
  '&:hover': { color: 'text.primary' },
  ...getFocusRingStyles('0px'),
};
